import type {CacheKeys} from 'src/hooks/common-data-service/cached-table';
import type {MemberInfo} from 'src/openapi/admin/models/MemberInfo';

export enum GroupSortField {
    GROUP_NAME = 'GROUP_NAME',
}

export type GroupsTabFilters = {
    name?: string,
};

export type GroupsTabCacheKeys = CacheKeys<undefined, GroupSortField, GroupsTabFilters>;

export type UpdateGroupMembersRequest = {
    addMembers?: MemberInfo[],
    removeMembers?: MemberInfo[],
};

export type GroupSelect = {
    groupId: number,
    view: string,
};
